// extracted by mini-css-extract-plugin
export default {"backContainer":"Admin_backContainer__rxo7E","back":"Admin_back__aGcf2"};